/* eslint-disable @typescript-eslint/no-explicit-any */
import Keycloak from 'keycloak-js'
import axios, { AxiosInstance } from 'axios';
const baseURL: string | undefined = process.env.REACT_APP_API_BASE_URL;
const jsonUrl =  baseURL ? (baseURL + (baseURL.endsWith('/') ? 'auth/config' : '/auth/config')) : '/keycloak.json';
const _kc = new Keycloak(jsonUrl)
let grantedResources:any;
/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback: () => void) => {
  _kc
    .init({
      checkLoginIframe: true,
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + process.env.PUBLIC_URL + '/silent-check-sso.html',
      pkceMethod: 'S256',
    })
    .then((authenticated) => {
      if (!authenticated || !isLoggedIn()) {
        console.warn('user is not authenticated..!')
        doLogin()
      }
      ensureGrantedRespurcesMap(_kc.token);
      onAuthenticatedCallback()
    })
    .catch(console.error)
}
const doLogin = _kc.login
const doLogout = _kc.logout
const getToken = () => _kc.token
const getTokenParsed = () => _kc.tokenParsed
const ensureGrantedRespurcesMap = async (token:string|undefined) =>{
  if(!grantedResources){
    
    const client:AxiosInstance = axios.create({ baseURL });
    try {
      const response = await client({
          url: '/auth/user-resources',
          headers:{
            'Authorization' : `Bearer ${token}`
          },
          method: 'GET'
      });
      grantedResources={};
      response.data.forEach((item: any) => {
        grantedResources[item.rsname] = item;
      });
    } catch (err: any) {
        console.error('Error loading granted resources' ,err);
    }
  }
}
const isLoggedIn = () => !!_kc.token
_kc.onTokenExpired = () => {
  _kc
    .updateToken(5)
    .then(() => {})
    .catch(doLogin)
}
const isTokenGoingToExpire = (): boolean =>
  (_kc.tokenParsed?.exp || 0) + 60000 < Math.round(new Date().getTime() / 1000)
const updateToken = (successCallback: any): Promise<boolean | void> => {
  if (isTokenGoingToExpire()) {
    return _kc.updateToken(5).then(successCallback).catch(doLogin)
  }
  return Promise.resolve().then(successCallback)
}
const getUsername = () => {
  // console.log(_kc.tokenParsed)
  return _kc.tokenParsed?.preferred_username || _kc.tokenParsed?.name
}
const getEmail = () => {
  return _kc.tokenParsed?.email
}
const hasRole = (roles: string[]) => {
  let existRole = roles.some((role: string) => _kc.hasRealmRole(role))
  if (!existRole && _kc.tokenParsed)
    existRole = roles.some((role: string) => _kc.hasResourceRole(role, _kc.tokenParsed?.azp))
  return existRole
}
const hasPermission = (rsname: string) => {
  /* se puede desabilitar la funcionalidad de validar permisos configurando la variable d
      de entorno PERMISSIONS_FEATURE_DISABLED=true*/
  if(process.env.PERMISSIONS_FEATURE_DISABLED){
    return true;
  }
  return grantedResources!=undefined && grantedResources[rsname]!=undefined;
}
const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  updateToken,
  getUsername,
  getEmail,
  hasRole,
  hasPermission,
  isTokenGoingToExpire,
}
export default UserService